module.exports = __webpack_public_path__ + "media/react/pages/lessons/show/activities/assets/concept_check_icon-5d07801480cca9065e69df7a22d2096b.svg";